import { writable, derived } from "svelte/store";

class Sidebar {
    constructor() {
        this.highlightedTopic = null;
    }
}

const createSidebarStore = () => {
    const { subscribe, set, update } = writable(new Sidebar());

    return {
        subscribe,
        set,
        update,
        highlightTopic: (topicId) =>
            update((sidebar) => {
                sidebar.highlightedTopic = topicId;
                return sidebar;
            }),
    };
};

export const SidebarStore = createSidebarStore();
export const highlightedTopic = derived(
    SidebarStore,
    ($sidebar) => $sidebar.highlightedTopic,
);
